import { FC, memo } from 'react'
import { BoxProps, Highlight } from '@chakra-ui/react'

type Props = BoxProps & {
  query?: string
  children: any
}

const CustomHighlight: FC<Props> = ({ query = '', ...props }) => {
  return (
    <Highlight query={query || ''} {...props} styles={{ rounded: 'sm', py: '1px', color: 'light', bg: 'primary' }}>
      {props.children || ''}
    </Highlight>
  )
}

export default memo(CustomHighlight)
